
  // ─── REAL VARIANT PRICING DATA (from Shopify) ───
  const VARIANT_PRICES = {
    "6-1/8":  {"5":5.25,"10":10.50,"15":15.75,"20":21.00,"25":26.25,"50":52.50,"100":100.00,"200":200.00,"500":450.00,"600":540.00,"700":630.00,"800":720.00,"900":810.00,"1000":900.00},
    "6-1/4":  {"5":5.75,"10":11.50,"15":17.25,"20":23.00,"25":28.75,"50":57.50,"100":110.00,"200":220.00,"300":330.00,"400":440.00,"500":500.00,"600":600.00,"700":700.00,"800":800.00,"900":900.00,"1000":1000.00},
    "6-3/8":  {"5":6.50,"10":13.00,"15":19.50,"20":26.00,"25":32.50,"50":65.00,"100":125.00,"200":250.00,"300":375.00,"400":500.00,"500":550.00,"600":660.00,"700":770.00,"800":880.00,"900":990.00,"1000":1100.00},
    "6-1/2":  {"5":7.75,"10":15.50,"15":23.25,"20":31.00,"25":38.75,"50":77.50,"100":150.00,"200":300.00,"300":450.00,"400":600.00,"500":675.00,"600":945.00,"700":945.00,"800":1080.00,"900":1215.00,"1000":1350.00},
    "6-3/4":  {"5":8.75,"10":17.50,"15":26.25,"20":35.00,"25":43.75,"50":87.50,"100":165.00},
    "6-1":    {"5":12.25,"10":24.50,"15":36.75,"20":49.00,"25":61.25,"50":122.50,"100":235.00,"200":470.00,"300":705.00,"400":940.00,"500":1175.00,"600":1410.00,"700":1645.00,"800":1880.00,"900":2115.00,"1000":2350.00},
    "5-1/4":  {"5":5.50,"10":11.00,"15":16.50,"25":27.50,"50":55.00,"100":105.00},
    "5-3/8":  {"5":6.00,"10":12.00,"15":18.00,"25":30.00,"50":60.00,"100":115.00},
    "5-1/2":  {"5":7.25,"10":14.50,"15":21.75,"25":36.25,"50":72.50,"100":140.00},
    "7-1/8":  {"5":5.50,"10":11.00,"15":16.50,"25":27.50,"30":33.00,"35":38.50,"40":44.00,"45":49.50,"50":55.00,"100":105.00},
    "7-1/4":  {"5":6.00,"10":12.00,"15":18.00,"25":30.00,"50":60.00,"100":115.00},
    "7-3/8":  {"5":6.75,"10":13.50,"15":20.25,"25":33.75,"50":67.50,"100":130.00},
    "7-1/2":  {"5":8.25,"10":16.50,"15":24.75,"25":33.00}
  };

  // ─── DYNAMIC PRICE UPDATE ───
  function updatePrice(pillsContainer) {
    const card = pillsContainer.closest('.product-card');
    const productKey = pillsContainer.dataset.product; // e.g. "6-1/4"
    const selectedPill = pillsContainer.querySelector('.qty-pill.selected');
    if (!selectedPill || !productKey || !VARIANT_PRICES[productKey]) return;

    const qty = selectedPill.dataset.qty;
    const prices = VARIANT_PRICES[productKey];
    const totalPrice = prices[qty];
    if (totalPrice === undefined) return;

    const perPiece = (totalPrice / parseInt(qty)).toFixed(2);
    const basePrice = prices[Object.keys(prices)[0]]; // price for smallest qty
    const basePPP = (basePrice / parseInt(Object.keys(prices)[0])).toFixed(2);
    const saving = basePPP > perPiece;

    // Update displayed price
    const priceEl = card.querySelector('.price-value');
    const priceFromEl = card.querySelector('.price-from');
    const bulkNoteEl = card.querySelector('.bulk-note');

    if (priceEl) priceEl.textContent = '$' + totalPrice.toFixed(2);
    if (priceFromEl) {
      priceFromEl.textContent = qty + ' piece' + (parseInt(qty) > 1 ? 's' : '') + ' — $' + perPiece + '/ea';
    }
    if (bulkNoteEl) {
      if (saving) {
        const pctOff = Math.round((1 - perPiece / basePPP) * 100);
        bulkNoteEl.textContent = '↓ ' + pctOff + '% off per piece';
        bulkNoteEl.style.color = 'var(--accent-dark)';
        bulkNoteEl.style.fontWeight = '500';
      } else {
        bulkNoteEl.textContent = '↓ Save with bulk';
        bulkNoteEl.style.color = '';
        bulkNoteEl.style.fontWeight = '';
      }
    }
  }

  // ─── TAB SWITCHING ───
  function switchTab(panelId, btn) {
    // Already active — nothing to do
    if (btn.classList.contains('active')) return;
    // Deactivate all tabs and panels
    document.querySelectorAll('.length-tab').forEach(t => t.classList.remove('active'));
    document.querySelectorAll('.product-panel').forEach(p => p.classList.remove('active'));
    // Activate selected
    btn.classList.add('active');
    document.getElementById('panel-' + panelId).classList.add('active');
  }

  // ─── QUANTITY PILL SELECTION + LIVE PRICE UPDATE ───
  document.addEventListener('click', function(e) {
    if (e.target.classList.contains('qty-pill')) {
      const container = e.target.closest('.qty-pills');
      container.querySelectorAll('.qty-pill').forEach(p => p.classList.remove('selected'));
      e.target.classList.add('selected');
      updatePrice(container);
    }
  });

  // ─── INIT: run price update on all cards on load ───
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.qty-pills').forEach(container => updatePrice(container));
  });

  // ─── CART COUNT UPDATE (Bug #1 fix) ───
  function refreshCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(data => {
        const cartBtn = document.querySelector('.cart-btn');
        if (cartBtn) {
          cartBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 16 16" fill="none"><path d="M1 1h2l2.4 7.39a1 1 0 00.95.61h5.7a1 1 0 00.95-.68l1.5-4.82H3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><circle cx="6.5" cy="13.5" r="1" fill="currentColor"/><circle cx="11.5" cy="13.5" r="1" fill="currentColor"/></svg> Cart (' + data.item_count + ')';
        }
      });
  }

  // Run on page load so count is accurate from the start
  document.addEventListener('DOMContentLoaded', refreshCartCount);

  // Listen for cart:refresh events dispatched after add
  document.addEventListener('cart:refresh', refreshCartCount);

  // ─── CART BUTTON LINK (Bug #3 fix) ───
  document.addEventListener('DOMContentLoaded', function() {
    const cartBtn = document.querySelector('.cart-btn');
    if (cartBtn) {
      cartBtn.addEventListener('click', function() {
        window.location.href = '/cart';
      });
      cartBtn.style.cursor = 'pointer';
    }
  });

  // ─── ADD TO CART ───
  const CART_BTN_INNER = '<svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M1 1h2l2.4 7.39a1 1 0 00.95.61h5.7a1 1 0 00.95-.68l1.5-4.82H3" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><circle cx="6.5" cy="13.5" r="1" fill="white"/><circle cx="11.5" cy="13.5" r="1" fill="white"/></svg> Add to Cart';

  function addToCart(btn) {
    const card = btn.closest('.product-card');
    const productKey = card.querySelector('.qty-pills')?.dataset.product;
    const selectedQty = card.querySelector('.qty-pill.selected')?.dataset.qty || '5';

    // Look up the variant ID for this product + quantity tier
    const variantMap = window.OA_VARIANTS && window.OA_VARIANTS[productKey];
    let variantId = variantMap && (variantMap[selectedQty] || variantMap[parseInt(selectedQty)]);

    // Fallback to the hardcoded data-variant-id if OA_VARIANTS lookup fails
    if (!variantId) variantId = card.dataset.variantId;

    if (!variantId) {
      console.warn('No variant ID found for', productKey, selectedQty);
      return;
    }

    btn.disabled = true;
    btn.innerHTML = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
    })
    .then(res => {
      // Bug #2 fix: check for errors before treating as success
      if (!res.ok) return res.json().then(err => Promise.reject(err));
      return res.json();
    })
    .then(() => {
      btn.innerHTML = '✓ Added ' + selectedQty + ' pcs to cart!';
      btn.style.background = 'var(--accent-dark)';
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      setTimeout(() => {
        btn.innerHTML = CART_BTN_INNER;
        btn.style.background = '';
        btn.disabled = false;
      }, 2000);
    })
    .catch((err) => {
      console.error('Cart add failed:', err);
      btn.innerHTML = 'Error — try again';
      setTimeout(() => {
        btn.innerHTML = CART_BTN_INNER;
        btn.disabled = false;
      }, 2000);
    });
  }

  // ─── SMOOTH SCROLL + NAV LENGTH LINKS ───
  document.addEventListener('DOMContentLoaded', function() {

    // Generic smooth scroll for all anchor links
    document.querySelectorAll('a[href^="#"]').forEach(link => {
      link.addEventListener('click', function(e) {
        const target = document.querySelector(this.getAttribute('href'));
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });

    // Length-tab nav links — scroll to shop then activate the right tab
    const link5 = document.querySelector('a[href="#5inch"]');
    const link6 = document.querySelector('a[href="#6inch"]');
    const link7 = document.querySelector('a[href="#7inch"]');

    if (link5) {
      link5.addEventListener('click', function(e) {
        e.preventDefault();
        document.getElementById('shop').scrollIntoView({ behavior: 'smooth' });
        setTimeout(() => {
          const tab = document.querySelector('.length-tab:nth-child(2)');
          if (tab) tab.click();
        }, 400);
      });
    }

    if (link6) {
      link6.addEventListener('click', function(e) {
        e.preventDefault();
        document.getElementById('shop').scrollIntoView({ behavior: 'smooth' });
        setTimeout(() => {
          const tab = document.querySelector('.length-tab:nth-child(1)');
          if (tab) tab.click();
        }, 400);
      });
    }

    if (link7) {
      link7.addEventListener('click', function(e) {
        e.preventDefault();
        document.getElementById('shop').scrollIntoView({ behavior: 'smooth' });
        setTimeout(() => {
          const tab = document.querySelector('.length-tab:nth-child(3)');
          if (tab) tab.click();
        }, 400);
      });
    }

  });

// ─── NEWSLETTER FORM ───
const newsletterForm = document.getElementById('newsletter-form');
if (newsletterForm) {
  newsletterForm.addEventListener('submit', function(e) {
    e.preventDefault();
    const form = e.target;
    const btn = form.querySelector('.newsletter-btn');
    const msg = form.querySelector('.newsletter-msg');

    btn.textContent = 'Subscribing...';
    btn.disabled = true;

    fetch(form.action, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams(new FormData(form)).toString()
    })
    .then(res => {
      if (res.ok) {
        msg.textContent = "You're in! Check your inbox for a confirmation.";
        msg.className = 'newsletter-msg success';
        form.querySelector('.newsletter-form').style.display = 'none';
      } else {
        throw new Error();
      }
    })
    .catch(() => {
      msg.textContent = 'Something went wrong. Please try again.';
      msg.className = 'newsletter-msg error';
      btn.textContent = 'Subscribe';
      btn.disabled = false;
    });
  });
}
